module.exports = {"430302001":"雨湖路街道","430302002":"城正街街道","430302003":"云塘街道","430302004":"广场街道","430302005":"窑湾街道","430302006":"昭潭街道","430302007":"万楼街道","430302008":"先锋街道","430302100":"鹤岭镇","430302101":"楠竹山镇","430302102":"姜畲镇","430302202":"长城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430302.json
// module id = 1949
// module chunks = 0